export enum JournalTypes {
	AllTypes = -1, // used only for searching
	Transfer = 1,
	BankEntry = 2,
	BudgetBuilder = 3,
}
